import { Inputfiledsbase } from './models/inputfiledsbase';

export class FileuploadQuestion extends Inputfiledsbase<string> {
  override controlType = 'fileupload';
}